<!-- TITLE -->
<div class="bmark-summary__fixings__title">
  {{ data.displayedFixingsType === BmarkFixingType.ACTIVE ? label.title.activeFixings :
  data.displayedFixingsType === BmarkFixingType.RECENT ? label.title.recentFixings : '' }}
</div>
<div
  class="bmark-summary__fixings__container"
  [ngClass]="{'active' : data.displayedFixingsType === BmarkFixingType.ACTIVE}"
>
  <!-- BODY - LISTING -->
  <div #bmarkSummaryFixingsBody class="bmark-summary__fixings__body">
    <div class="bmark-summary__fixings__fixings-list">
      <ng-container
        *ngIf="data.displayedFixingsList != null && Array.isArray(data.displayedFixingsList) && data.displayedFixingsList.length > 0; then fixingsListing else noRecords"
      >
      </ng-container>
    </div>
  </div>
</div>

<!-- TEMPLATES  -->
<ng-template #fixingsListing>
  <div
    *ngFor="let fixing of data.displayedFixingsList"
    class="bmark-summary__fixings__fixing-tile__container"
  >
    <div
      [ngClass]="{
        'bmark-summary__fixings__fixing-tile': true,
        'bmark-summary__fixings__fixing-tile--hard-cutoff': fixing.displayColor === BmarkFixingTileColor.HCO,
        'bmark-summary__fixings__fixing-tile--soft-cutoff': fixing.displayColor ===  BmarkFixingTileColor.SCO,
        'bmark-summary__fixings__fixing-tile--today': fixing.displayColor === BmarkFixingTileColor.TODAY,
        'bmark-summary__fixings__fixing-tile--future': fixing.displayColor === BmarkFixingTileColor.FUTURE,
        'bmark-summary__fixings__fixing-tile--completed': fixing.displayColor === BmarkFixingTileColor.COMPLETED,
        'bmark-summary__fixings__fixing-tile--active': fixing.displayColor === BmarkFixingTileColor.ACTIVE,
        'bmark-summary__fixings__fixing-tile--fwd-pending': fixing.displayColor === BmarkFixingTileColor.FWD_PENDING,
        'bmark-summary__fixings__fixing-tile--selected': fixing.id === data.selectedFixingId && fixing.type === data.selectedFixingType
      }"
      (click)="displayFixing(fixing)"
    >
      <div class="fixing-time-date-container">
        <div class="bmark-summary__fixings__fixing-tile__time">
          <!-- Use a fixing-time pipe parameterised with the desired timezone -->
          <span>{{fixing | fixingTime:displayTZ}}</span>
        </div>
        <div class="bmark-summary__fixings__fixing-tile__date">
          <span>{{fixing | fixingDate:displayTZ}}</span>
        </div>
      </div>
      <div class="bmark-summary__fixings__fixing-tile__code">
        <span class="fixing-tile-name-text" [title]="fixing.displayCodeTooltip">
          {{fixing.code}}
        </span>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #noRecords>
  <div><!-- such empty --></div>
</ng-template>
